import { type BlockConfig, iconField } from './_types';

/**
 * Payload `Block` config sidecar for the `twoPillars` block.
 *
 * Decomposed from `src/components/protect/TwoPillarsSection.tsx`. Slug is
 * fixed by the Plan v3 inventory but the block actually supports 2-6
 * pillars; the React component switches to a 3-column grid via the
 * `columns` field for 5-6 pillars.
 *
 * Slug + interfaceName naming reconciliation:
 *   File name:               `two-pillars.tsx` / `two-pillars.payload.ts`
 *   React component export:  `TwoPillars`
 *   Payload `slug`:          `twoPillars`
 *   Payload `interfaceName`: `TwoPillarsBlock`
 */

export const TwoPillarsBlock: BlockConfig = {
  slug: 'twoPillars',
  interfaceName: 'TwoPillarsBlock',
  labels: {
    singular: 'Two Pillars',
    plural: 'Two Pillars Blocks',
  },
  fields: [
    {
      name: 'eyebrow',
      type: 'text',
      label: 'Eyebrow',
    },
    {
      name: 'headline',
      type: 'textarea',
      required: true,
      label: 'Headline',
      admin: { rows: 2 },
    },
    {
      name: 'subheadline',
      type: 'textarea',
      label: 'Subheadline',
      admin: { rows: 2 },
    },
    {
      name: 'columns',
      type: 'select',
      defaultValue: '2',
      label: 'Columns',
      options: [
        { label: '2', value: '2' },
        { label: '3', value: '3' },
      ],
    },
    {
      name: 'pillars',
      type: 'array',
      required: true,
      minRows: 2,
      maxRows: 6,
      label: 'Pillars',
      labels: { singular: 'Pillar', plural: 'Pillars' },
      fields: [
        iconField({
          name: 'icon',
          label: 'Icon (lucide-react name)',
          required: true,
        }),
        { name: 'title', type: 'text', required: true, label: 'Title' },
        {
          name: 'description',
          type: 'textarea',
          required: true,
          label: 'Description',
          admin: { rows: 3 },
        },
      ],
    },
  ],
};

export default TwoPillarsBlock;
